import { useUtmTracker } from '@/hooks/use-utm-tracker';

export function UtmTracker() {
  useUtmTracker();
  return null;
}
